// src/components/Calendar/CalendarView.js
import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

export default function CalendarView({
  events,
  calendarRef,
  onEventClick,
  onDateClick,
  eventClassNames,
}) {
  return (
    <FullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      headerToolbar={{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay',
      }}
      height="100%"
      events={events}
      eventClassNames={eventClassNames}
      eventClick={(info) => onEventClick(info.event)}
      dateClick={(info) => onDateClick(info.date)}
    />
  );
}
